import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import './directive';
import { get_salary as _get_salary, save_salary } from 'api/payroll/salary-scheme/detail';
import { isDeleteToast, deleteItemImport } from 'api/payroll/wage/step2';
import Management from '../../compontents/management.vue';
import example from '../components/example';
import { fullAttendanceBonusList } from '@/api/payroll/management';
export default {
  props: {
    activeObj: {
      type: Object
    }
  },
  components: {
    Management: Management,
    example: example
  },
  data: function data() {
    return {
      fixTable: {
        id: '',
        name: '',
        list: []
      },
      // 上边的表格
      days: [],
      // 下拉框
      not_days: [],
      // 下拉框
      fixTableSelectArr: [],
      // 上面表格选中的
      activeNames: [0],
      activeNames1: [0],
      activeNames2: [0, 1, 2],
      activeNames3: [],
      notFixTable: {
        id: '',
        name: '',
        list: []
      },
      // 下面的表格
      notFixTableSelectArr: [],
      activeData: this.activeObj.data,
      activeInfo: this.activeObj.data.info,
      cActiveInfo: this.activeObj.data.cInfo,
      // 拷贝数据，判断是否修改
      is_show: false,
      // 是否展示全勤奖
      otDays: {},
      attendanceData: {},
      extend: {
        attendance_belong_to: {
          type: '',
          after: '',
          before: ''
        },
        overtime_belong_to: {
          type: '',
          after: '',
          before: ''
        },
        update_salary_day_last_later: {
          type: '',
          after: '',
          before: ''
        }
      }
    };
  },
  computed: {
    fixClo: function fixClo() {
      return this.$route.query.type === '2' ? this.activeData.fixClo1 : this.activeData.fixClo;
    },
    notFixClo: function notFixClo() {
      return this.activeData.notFixClo;
    }
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.attendance();
          case 2:
            _context.next = 4;
            return _this.get_salary();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    // 删除导入项
    handlerDel: function handlerDel(row) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return isDeleteToast(row);
            case 2:
              res = _context2.sent;
              if (res.data.is_del) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", _this2.$util.messageBox(_this2.$t('1387'), 'warning', function () {
                deleteItemImport(row).then(function () {
                  _this2.$message.success(_this2.$t('806'));
                  _this2.get_salary();
                });
              }));
            case 5:
              deleteItemImport(row).then(function () {
                _this2.$message.success(_this2.$t('806'));
                _this2.get_salary();
              });
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    get_salary: function get_salary() {
      var _this3 = this;
      // 工资设置数据
      _get_salary({
        payroll_sub_project_scheme_id: this.$route.params.id
      }).then(function (res) {
        if (res && res.code === 1) {
          var _res$data = res.data,
            fix = _res$data.fix,
            notfix = _res$data.notfix,
            days = _res$data.days,
            not_days = _res$data.not_days,
            extend = _res$data.extend;
          var formatData = [{
            data: fix,
            key: 'fixTable',
            active: 'activeNames1'
          }, {
            data: notfix,
            key: 'notFixTable',
            active: 'activeNames'
          }, {
            data: extend,
            key: 'extend',
            active: 'activeNames2'
          }];
          _this3.days = days;
          _this3.not_days = not_days;
          formatData.map(function (v, i) {
            _this3[v.active] = [];
            if (v.data && v.data.list) {
              v.data.list.forEach(function (table, tableIndex) {
                // 手风琴默认全部打开
                _this3[v.active].push(tableIndex);
                if (table.list) {
                  table.list.forEach(function (item) {
                    item.cate_id = table.id;
                    item.is_tax = item.is_tax === '1';
                    item.is_ss = item.is_ss === '1';
                    item.is_ewf = item.is_ewf === '1';
                  });
                }
              });
            } else _this3[v.active] = [0, 1, 2];
            // 给 notFixTable fixTable extend赋值
            _this3[v.key] = v.data;
          });
          _this3.$nextTick(function () {
            var info = {
              notFixTable: {},
              fixTable: {},
              extend: {}
            };
            formatData.map(function (v, i) {
              if (v.data && v.data.list) {
                v.data.list.forEach(function (table, tableIndex) {
                  info[v.key][tableIndex] = [];
                  if (table.ot_days) _this3.otDays = table.ot_days;
                  table.list.forEach(function (item) {
                    if (item.is_select === '1') {
                      info[v.key][tableIndex].push(item);
                      _this3.$refs["".concat(v.key).concat(tableIndex)][0].toggleRowSelection(item, true);
                    }
                  });
                  if (!info[v.key][tableIndex].length) delete info[v.key][tableIndex];
                });
              } else {
                info.extend = v.data;
              }
            });
            // 拷贝初始数据
            _this3.cActiveInfo.notFixTable = JSON.parse(JSON.stringify(info.notFixTable));
            _this3.cActiveInfo.fixTable = JSON.parse(JSON.stringify(info.fixTable));
            _this3.cActiveInfo.extend = JSON.parse(JSON.stringify(extend));
          });
        }
      });
    },
    // 请求
    attendance: function attendance() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return fullAttendanceBonusList();
            case 2:
              res = _context3.sent;
              if (!(res.code !== 1 && res.data)) {
                _context3.next = 5;
                break;
              }
              return _context3.abrupt("return");
            case 5:
              _this4.attendanceData = res.data;
              _this4.is_show = _this4.attendanceData.pfa_list && _this4.attendanceData.pfa_list.length;
              if (_this4.is_show) {
                _this4.attendanceData.pfa_list.forEach(function (item) {
                  item.is_ss = item.is_ss === '1';
                  item.is_tax = item.is_tax === '1';
                  item.provide_way_1 = item.provide_way_1 ? item.provide_way_1 : {
                    1: '',
                    2: '',
                    3: '',
                    4: ''
                  };
                  item.staff = [].concat(_toConsumableArray(item.department_id), _toConsumableArray(item.staff_info_ids));
                });
              }
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    handleGroup: function handleGroup(val) {
      this.$set(this.extend[val], 'after', '');
      this.$set(this.extend[val], 'before', '');
      // this.extend[val].after = ''
      // this.extend[val].before = ''
    },
    handleOtDays: function handleOtDays(val) {
      this.otDays = val;
    },
    saveData: function saveData() {
      var _this5 = this;
      this.notFixTableSelectArr = [];
      this.fixTableSelectArr = [];
      for (var k in this.activeInfo.notFixTable) {
        this.activeInfo.notFixTable[k].forEach(function (v) {
          return _this5.notFixTableSelectArr.push(v);
        });
      }
      for (var _k in this.activeInfo.fixTable) {
        this.activeInfo.fixTable[_k].forEach(function (v) {
          return _this5.fixTableSelectArr.push(v);
        });
      }
      var update_salary_day_last_later = this.extend.update_salary_day_last_later;
      if (update_salary_day_last_later && Number(update_salary_day_last_later.type) === 3 && !update_salary_day_last_later.before && !update_salary_day_last_later.after) {
        this.$message.warning(this.$t('i18n.5653d71db6d74c1d96d8f9585dbe0f05'));
        return;
      }
      var formateData = function formateData(arr, withEwf) {
        return arr.map(function (v) {
          var row = {
            id: v.id,
            cate_id: v.cate_id,
            val: v.val,
            is_ss: v.is_ss ? '1' : '0',
            is_tax: v.is_tax ? '1' : '0',
            days_type: v.days_type,
            days: v.days,
            not_days: v.not_days
          };
          if (withEwf) row.is_ewf = v.is_ewf ? '1' : '0';
          return row;
        });
      };
      var query = {
        payroll_sub_project_scheme_id: this.$route.params.id,
        fix: formateData(this.fixTableSelectArr),
        notfix: formateData(this.notFixTableSelectArr, true),
        extend: this.extend
      };
      if (Object.keys(this.otDays).length) query.ot_days = this.otDays;
      return save_salary(query);
    },
    selectable: function selectable(row) {
      return row.if_select === '1';
    },
    notFixTableSelectHandle: function notFixTableSelectHandle($event, index, obj) {
      this.activeInfo[obj][index] = $event;
    },
    check: function check(row, max) {
      Number(row.val) > max && (row.val = max);
      Number(row.val) < 0 && (row.val = '');
      row.val = Number(Number(row.val).toFixed(1));
    },
    checkExample: function checkExample(type) {
      this.$refs.example.init(type);
    }
  }
};